import React from 'react';
import {withRouter, Route, Switch} from 'react-router-dom';
import RegisterForm from './register-form';
import PropTypes from 'prop-types';
import Confirmation from './confirmation';
import qs from 'qs';
import config from '../config';
const {apiUrl} = config;

class Register extends React.Component {
  constructor(props) {
    super(props);
    const {search} = this.props.location;
    const {coin: name} = search ? qs.parse(search.substring(1)) : {};
    this.state = {
      _id: props.match.params._id,
      errorStatus: null,
      name,
      firstname: '',
      lastname: '',
      email: '',
      company: '',
      phone: ''
    };
  }
  handleChange = (key, value) => {
    const newState = {[key]: value};
    if (key === 'name') {
      newState.errorStatus = null;
    }
    this.setState(newState);
  }

  submit = data => {

    fetch(`${apiUrl}/coins`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(resp => {
        if (resp.status === 201) {
          return resp.json();
        } else {
          throw {status: resp.status};
        }
      })
      .then(resp => {
        this.setState({_id: resp._id});
        this.props.history.push(`/register/${resp._id}/confirmation`);
      })
      .catch(err => {
        if (err.status) {
          this.setState({errorStatus: err.status});
        }
      });
  }

  render() {

    return (
      <Switch>
        <Route path='/register/:_id/confirmation' render={() => {
          return <Confirmation name={this.state.name} _id={this.state._id} />;
        }} />
        <Route path="/register" render={() => {
          return <RegisterForm
            errorStatus={this.state.errorStatus}
            handleChange={this.handleChange}
            onSubmit={this.submit}
            {...this.state}
          />;

        }} />

      </Switch>
    );
    // if (this.state._id) {
    //   return (
    //     <div>
    //       <Route path='/register/:_id/confirmation' render={() => {
    //         return 'confirmation';
    //       }} />
    //     </div>
    //   );
    // } else {
    //   return <RegisterForm
    //     errorStatus={this.state.errorStatus}
    //     handleChange={this.handleChange}
    //     onSubmit={this.submit}
    //     {...this.state}
    //   />;
    // }
  }
}

Register.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      _id: PropTypes.string
    })
  })
};

export default withRouter(Register);



// WEBPACK FOOTER //
// ./src/register/index.js